import { defaultPerson } from "features/production"
import { IPerson } from "features/production/models/Person"
import { IAppTheme, defaultAppTheme } from "themes/commonStyles"


export interface IApplicationSetup {
    id: number,
    companyName: string,
    description: string,
    defaultLanguage: string,
    defaultCustomerId: number,

    defaultCustomer: IPerson,

    isPasswordComplexityAllowed: boolean,
    passwordDuration: number,
    passwordRotation: number,
    maxAccessFailedCount: number,
    accessLockoutDuration: number,

    applicationApiToken: string,
    websiteApplicationApiToken: string,
    
    whatsAppBaseUrl: string,
    whatsAppIdentityToken: string,
    whatsAppLogin: string,
    whatsAppPasswordMd5: string,

    whatsAppPassword: string,
    isPasswordChanged: boolean,

    webhookToken: string,
    webhookUrl: string,

    isCommissionDisburseOn: boolean,
    minimumDisbursementCommissionAmount: number,

    valueOfPoint: number,
    minimumDisbursementPointCount: number,

    minAppointmentStartTime: Date,
    maxAppointmentStartTime: Date,
    onlineAppointmentNotificationMode: string,

    appointmentValidationNotificationReportId: number,
    appointmentValidationNotificationTransmissionMode: string,
    appointmentValidationNotificationRetentionMode: string,
    appointmentValidationNotificationReportName: string,
    appointmentContactAllowedForTechnician: boolean,
    appointmentAllAvailableForTechnician: boolean,

    certificateSmsExpression: string,

    certificateDocumentExpression: string,
    certificateImageExpression: string,
    certificateQrCodeExpression: string,    
    
    isSmsOn: boolean,
    isWhatsAppOn: boolean,
    isReportScheduleOn: boolean,
    isFeatureScheduleOn: boolean,
    notificationWhatsAppNumber1: string,
    notificationWhatsAppNumber2: string,

    issuePeriod: number,
    isAutomaticIssueDate: boolean,
    issueDateMaxDelayMonthClosing: number,
    issueDateMaxDelayYearClosing: number,
    isAutomaticClosedAfterDelay: boolean,

    proformaNumberExpression: string,
    billingNumberExpression: string,
    tellerOperationNumberExpression: string,

    deliveryNumberExpression: string,
    purchaseOrderNumberExpression: string,
    expenseNumberExpression: string,

    resetProformaSequenceByYear: boolean,
    resetBillingSequenceByYear: boolean,
    resetTellerOperationSequenceByYear: boolean,
    resetDeliverySequenceByYear: boolean,
    resetPurchaseOrderSequenceByYear: boolean,
    resetExpenseSequenceByYear: boolean,

    resetProformaSequenceByMonth: boolean,
    resetBillingSequenceByMonth: boolean,
    resetTellerOperationSequenceByMonth: boolean,
    resetDeliverySequenceByMonth: boolean,
    resetPurchaseOrderSequenceByMonth: boolean,
    resetExpenseSequenceByMonth: boolean,

    defaultCurrencyCode: string,
    defaultOnlineStoreId: number,
    defaultTaxRate: number,
    isTaxRateVariable: boolean,

    smtpServer: string,
    smtpPort: number,
    smtpUsername: string,
    smtpPassword: string,
    smtpSenderEmail: string,
    smtpUseTls: boolean,
    smtpServerType: string,

    ticketStartResolutionCode: string,
    ticketEndResolutionCode: string,
    defaultTicketDurationHours: number,

    allowServiceWithoutTechnician: boolean,

    autoGenerateProformaSequence: boolean,
    isBillingConsumptionProfil: boolean,
    maxHourDuration4ConsumptionBilling: number,

    isPayPalLive: boolean,
    payPalClientID: string,
    payPalSecretKey: string,
    payPalPaymentSourceCode: string,

    isStripeLive: boolean,
    stripeClientID: string,
    stripePrivateKey: string,
    stripePublicKey: string,
    stripePaymentSourceCode: string,

    firstLineOfBusinessCode: string,
    secondLineOfBusinessCode: string,
    thirdLineOfBusinessCode: string,

    firstProductionUnitCode: string,
    secondProductionUnitCode: string,
    thirdProductionUnitCode: string,

    loadProductOnLogon: boolean,

    isBillingDiscountEnabled: boolean,
    allowBillingDiscountAfterItemDiscount: boolean,
    maxBillingDiscountRate: number,

    hasService: boolean,
    hasFee: boolean,
    hasArticle: boolean,
    hasPackaging: boolean,
    hasFormation: boolean,
    hasMaintenance: boolean,
    hasContract: boolean,

    hasRental: boolean,
    hasConsumption: boolean,

    hasShiping: boolean,
    hasLaundry: boolean,

    hasExam: boolean,

    applicationTheme: IAppTheme
  }


  export const defaultApplicationSetup : IApplicationSetup = {
    id: 0,
    companyName: '',
    description: '',
    defaultLanguage: '',
    defaultCustomerId: 0,
    
    defaultCustomer: defaultPerson,

    isPasswordComplexityAllowed: false,
    passwordDuration: 0,
    passwordRotation: 0,
    maxAccessFailedCount: 0,
    accessLockoutDuration: 0,

    applicationApiToken: '',
    websiteApplicationApiToken: '',
    
    whatsAppBaseUrl: '',
    whatsAppIdentityToken: '',
    whatsAppLogin: '',
    whatsAppPasswordMd5: '',

    whatsAppPassword: '',
    isPasswordChanged: false,

    webhookToken: '',
    webhookUrl: '',

    isCommissionDisburseOn: true,
    minimumDisbursementCommissionAmount: 10000,

    valueOfPoint: 0,
    minimumDisbursementPointCount: 0,

    minAppointmentStartTime: new Date(),
    maxAppointmentStartTime: new Date(),
    onlineAppointmentNotificationMode: '',

    appointmentValidationNotificationReportId: 0,
    appointmentValidationNotificationTransmissionMode: '',
    appointmentValidationNotificationRetentionMode: '',
    appointmentValidationNotificationReportName: '',
    appointmentContactAllowedForTechnician: false,
    appointmentAllAvailableForTechnician: false,

    certificateSmsExpression: '',

    certificateDocumentExpression: '',
    certificateImageExpression: '',
    certificateQrCodeExpression: '',

    isSmsOn: true,
    isWhatsAppOn: true,
    isReportScheduleOn: true,
    isFeatureScheduleOn: true,
    notificationWhatsAppNumber1: '',
    notificationWhatsAppNumber2: '',

    issuePeriod: (new Date()).getFullYear()*100+1,
    isAutomaticIssueDate: true,
    issueDateMaxDelayMonthClosing: 0,
    issueDateMaxDelayYearClosing: 0,
    isAutomaticClosedAfterDelay: false,

    proformaNumberExpression: '',
    billingNumberExpression: '',
    tellerOperationNumberExpression: '',
    deliveryNumberExpression: '',
    purchaseOrderNumberExpression: '',
    expenseNumberExpression: '',

    resetProformaSequenceByYear: true,
    resetBillingSequenceByYear: true,
    resetTellerOperationSequenceByYear: true,
    resetDeliverySequenceByYear: true,
    resetPurchaseOrderSequenceByYear: true,
    resetExpenseSequenceByYear: true,

    resetProformaSequenceByMonth: false,
    resetBillingSequenceByMonth: false,
    resetTellerOperationSequenceByMonth: false,
    resetDeliverySequenceByMonth: false,
    resetPurchaseOrderSequenceByMonth: false,
    resetExpenseSequenceByMonth: false,

    defaultCurrencyCode: '',
    defaultOnlineStoreId: 0,
    defaultTaxRate: 0,
    isTaxRateVariable: false,

    smtpServer: '',
    smtpPort: 0,
    smtpUsername: '',
    smtpPassword: '',
    smtpSenderEmail: '',
    smtpUseTls: false,
    smtpServerType: '',

    ticketStartResolutionCode: '',
    ticketEndResolutionCode: '',
    defaultTicketDurationHours: 0,

    allowServiceWithoutTechnician: false,

    autoGenerateProformaSequence: false,
    isBillingConsumptionProfil: false,
    maxHourDuration4ConsumptionBilling: 0,

    isPayPalLive: false,
    payPalClientID: '',
    payPalSecretKey: '',
    payPalPaymentSourceCode: '',

    isStripeLive: false,
    stripeClientID: '',
    stripePrivateKey: '',
    stripePublicKey: '',
    stripePaymentSourceCode: '',

    firstLineOfBusinessCode: '',
    secondLineOfBusinessCode: '',
    thirdLineOfBusinessCode: '',

    firstProductionUnitCode: '',
    secondProductionUnitCode: '',
    thirdProductionUnitCode: '',

    loadProductOnLogon: false,

    isBillingDiscountEnabled: false,
    allowBillingDiscountAfterItemDiscount: false,
    maxBillingDiscountRate: 0,

    hasService: false,
    hasFee: false,
    hasArticle: false,
    hasPackaging: false,
    hasFormation: false,
    hasMaintenance: false,
    hasContract: false,
    hasRental: false,
    hasConsumption: false,

    hasShiping: false,
    hasLaundry: false,

    hasExam: false,

    applicationTheme: defaultAppTheme
  }

  export interface IMailRequest {
    recipient: string,
    messageObject: string,
    messageBody: string,
  }

  export const defaultMailRequest : IMailRequest = {
    recipient: '',
    messageBody: '',
    messageObject: ''
  }

  

  export interface IApplicationSetupSearch {
    companyName: string
  }